import React from "react";

import { Col, Icon, Link, Row, Typography } from "components";

export const PaymentInfo = ({ farm, t }) =>
  farm.bankingDetails && (
    <section className="padded-small payment-info">
      <section className="container tiny">
        <Row>
          <Col>
            <Typography variant="h2">
              {t("paymentInformation.title")}
              <Link to="/banking-details" mixpanelText="edit-banking-details" className="right">
                <Icon iconName="klim/edit-element" className="icon inline" />
              </Link>
            </Typography>
          </Col>
        </Row>
        <Row>
          <Col>
            <Typography variant="paragraph-m">{farm.bankingDetails.accountHolder}</Typography>
            <Typography variant="paragraph-m">
              {t("iban")}: {farm.bankingDetails.iban ? farm.bankingDetails.iban.slice(0, farm.bankingDetails.iban.length - 5).replace(/[^\s]/g, "-") : ""}
              {farm.bankingDetails.iban ? farm.bankingDetails.iban.slice(-5) : ""}
            </Typography>
          </Col>
        </Row>
      </section>
    </section>
  );
